// extracted by mini-css-extract-plugin
export default {"overlay":"overlay--iAuDX5Bw2S"};